export default __webpack_public_path__ + "static/media/bush.331a141b.png";